var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEasyReport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_2",
    "data-name": "Camada 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 863.19 1028.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 101.77,
    y: 657.23,
    width: 313.08,
    height: 28.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 101.77,
    y: 757.97,
    width: 313.08,
    height: 28.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 101.77,
    y: 858.73,
    width: 313.08,
    height: 28.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m763.08,586.07V0H226.16l-6.91,6.91-2.07,2.08-20.17,20.16L0,226.16v802.29h763.08v-111.51c59.48-31.29,100.12-93.72,100.12-165.45s-40.63-134.16-100.12-165.42Zm72.53,154.93c-15.88-17.35-33.87-32.3-53.79-44.96-19.63-12.45-40.62-21.9-63.23-27.64-43.28-10.97-84.55-4.77-124.37,14.26-24.63,11.8-46.6,27.44-66.18,46.37-3.73,3.62-7.33,7.37-10.85,11.2,5.77-82.87,74.83-148.3,159.15-148.3,20.3,0,39.72,3.8,57.57,10.7,10.27,3.98,20.03,8.98,29.15,14.89,41.1,26.65,69.16,71.69,72.53,123.47Zm-238.02-3.54c-6.1,29.75,1.39,55.33,22.34,77.23-32.94-12.57-60.63-32.75-85.14-58.38,4.21-4.16,8.19-8.23,12.35-12.11,20.86-19.32,44.11-34.9,70.55-45.6,2.81-1.14,4.4-.73,6.2,1.61,2.14,2.87,4.72,5.41,7.29,8.32,14.93-13.16,32.19-19.3,52.03-17.13,15.53,1.69,28.88,8.21,39.62,19.51,21.67,22.82,24.57,55.98,7.47,81.76-16.72,25.24-48.72,35.52-77.47,24.88-26.33-9.74-48.97-39.5-40.47-77.58-4.87-.82-9.51-1.62-14.76-2.5Zm158.75,19.13c.06-22.75-8.43-42.14-24.67-58.25,15.92,1.5,65.04,35,85.04,57.93-21,23.44-54.33,47.53-85.67,58.78,16.66-16.57,25.26-35.84,25.3-58.47ZM217.17,50.22v170.24H46.93L217.17,50.22Zm516.76,936.45H29.15V249.61h217.19V29.15h487.58v544.6c-18.14-5.88-37.48-9.08-57.57-9.08-103.02,0-186.82,83.8-186.82,186.82s83.8,186.84,186.82,186.84c20.09,0,39.43-3.19,57.57-9.08v57.42Zm29.15-101.21c-9.12,5.9-18.88,10.91-29.15,14.89-17.86,6.91-37.27,10.7-57.57,10.7-80.45,0-147.01-59.55-157.96-136.98,15.34,16.41,32.63,30.57,51.69,42.66,19.61,12.47,40.62,21.88,63.23,27.63,35.39,9.02,70.17,6.66,104.23-5.85,37.89-13.91,69.76-36.52,96.99-65.71-6.31,47.2-33.24,87.88-71.45,112.67Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 103.42,
    y: 372.32,
    width: 117.24,
    height: 115.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 242.49,
    y: 308.92,
    width: 117.23,
    height: 179.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 381.54,
    y: 244.25,
    width: 117.22,
    height: 243.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 520.59,
    y: 180.21,
    width: 139.07,
    height: 307.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m634.52,743.7c10.65,1.78,21.14,3.53,32.64,5.46-7.47-8.44-14.34-16.21-21.19-23.95,12.08-13.07,36.33-17.5,54.75-4.57,18.5,12.98,24.16,37.8,13.07,57.11-11.29,19.65-35.37,27.58-55.66,18.34-20.08-9.15-30.52-32.06-23.61-52.38Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEasyReport);
export default __webpack_public_path__ + "static/media/IconEasyReport.aa383c73795d49fdf7c3f77587b5f1a0.svg";
export { ForwardRef as ReactComponent };